<template>
  <div class="blocked-page">
    <h1>访问受限</h1>
    <p>当前网络环境无法访问本站，如有疑问请联系客服。</p>
  </div>
</template>

<script>
export default {
  name: 'IpBlocked',
};
</script>

<style scoped>
.blocked-page {
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #666;
  text-align: center;
}
.blocked-page h1 {
  font-size: 28px;
  color: #e7473c;
  margin-bottom: 16px;
}
</style>
